import { render, staticRenderFns } from "./lift.vue?vue&type=template&id=60ddbbe4"
import script from "./lift.vue?vue&type=script&lang=js"
export * from "./lift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports